module.exports = __webpack_public_path__ + "static/media/Data_Implementacao_de_Microservices.54180d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Data_Implementacao_de_Microservices.png
// module id = 123
// module chunks = 0